/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Favorite from "@material-ui/icons/Favorite";
import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";
import BusinessCenter from "@material-ui/icons/BusinessCenter";

import KisetsuNavbar from "components/Header/KisetsuNavbar";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Footer from "components/Footer/Footer.js";

import contactUsStyle from "assets/jss/material-kit-pro-react/views/contactUsStyle.js";

const useStyles = makeStyles(contactUsStyle);

// Ataşehir, İstanbul koordinatları
const CustomSkinMap = withScriptjs(
  withGoogleMap(() => (
    <GoogleMap
      defaultZoom={15}
      defaultCenter={{ lat: 40.9883624, lng: 29.1136743 }}
      defaultOptions={{
        scrollwheel: false,
        zoomControl: true,
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }]
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
          }
        ]
      }}
    >
      <Marker position={{ lat: 40.9883624, lng: 29.1136743 }} />
</GoogleMap>
  ))
);

export default function ContactUsPage() {
  const classes = useStyles();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  return (
    <div>
      <KisetsuNavbar/>
      <div className={classes.bigMap}>
        <CustomSkinMap
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCH21r5fKNJECbTm0HkRb_IHM-4laXPr-Y"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={
            <div
              style={{
                height: `100%`,
                borderRadius: "6px",
                overflow: "hidden"
              }}
            />
          }
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.contactContent}>
          <div className={classes.container}>
            <h2 className={classes.title}>Bize Ulaşın</h2>
            <GridContainer>
              <GridItem md={6} sm={6}>
                <p>
                  Ürünlerimizle ilgili her konuda bize ulaşabilirsiniz. En kısa sürede sizinle iletişime geçeceğiz.
                </p>
                <form>
                  <CustomInput
                    labelText="Adınız Soyadınız"
                    id="name"
                    formControlProps={{ fullWidth: true }}
                  />
                  <CustomInput
                    labelText="E-posta Adresiniz"
                    id="email"
                    formControlProps={{ fullWidth: true }}
                  />
                  <CustomInput
                    labelText="Telefon Numaranız"
                    id="phone"
                    formControlProps={{ fullWidth: true }}
                  />
                  <CustomInput
                    labelText="Mesajınız"
                    id="message"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{ multiline: true, rows: 6 }}
                  />
                  <div className={classes.textCenter}>
                    <Button color="primary" round>
                      Gönder
                    </Button>
                  </div>
                </form>
              </GridItem>

              <GridItem md={4} sm={4} className={classes.mlAuto}>
                <InfoArea
  className={classes.info}
  title="Adresimiz"
  description={
    <p>
      Atatürk Mahallesi, Yakut Caddesi <br />
      No: 4A, 20. Blok, Kat: 2, Daire: 6 <br />
      Ataşehir / İstanbul <br />
      <strong>34758</strong>
    </p>
  }
  icon={PinDrop}
  iconColor="primary"
/>

                <InfoArea
  className={classes.info}
  title="Telefon"
  description={
    <p>
      Kisetsu<br />
      <a href="tel:+905010635834">
        +90 501 063 58 34
      </a>
      <br />
      Hafta içi: 09:00 - 18:00
    </p>
  }
  icon={Phone}
  iconColor="primary"
/>

                <InfoArea
                  className={classes.info}
                  title="Yasal Bilgiler"
                  description={
                    <p>
                      Kisetsu Mottoviva'nın tescilli markasıdır. <br/>
                      <br />
                     MOTTOVİTA E-TİCARET PAZARLAMA İTHALAT İHRACAT SANAYİ VE TİCARET LİMİTED ŞİRKETİ <br />
                      <a href="mailto:info@mottovita.com">info@mottovita.com</a> 
  
                    </p>
                  }
                  icon={BusinessCenter}
                  iconColor="primary"
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="/blog-posts" className={classes.block}>Blog</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/about-us" className={classes.block}>Hakkımızda</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/products" className={classes.block}>Mağaza</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/contact-us" className={classes.block}>İletişim</a>
            </ListItem>
          </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , sevgiyle hazırlandı{" "}
              <Favorite className={classes.icon} />{" "}
              <a href="/" target="_blank" rel="noopener noreferrer">
                Kisetsu
              </a>{" "}
              ile daha planlı bir yaşam için.
            </div>
          </div>
        }
      />
    </div>
  );
}
